// extracted by mini-css-extract-plugin
export default {"step_4_container":"_2iqy","step_4_inner_container":"_2k_G"};